import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Link } from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Topo from '../Layout/Topo';
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';
import RequestApi from '../Miscelania/RequestApi';
import BotaoFinalizarProva from '../Miscelania/BotaoFinalizarProva';

const PropTypes = require('prop-types');

class ExamQuestion extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  
  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      questao: [],
      opcoes: [],
      questaoSelecionada: 'undefined',
      questoes_respondidas: 0,
      primeira_questao: 0,
      ultima_questao: 0,
      exam_id: 0
    };
    this.desativar_loading = this.desativar_loading.bind(this);
    this.verificarQuestaoSelecionada = this.verificarQuestaoSelecionada.bind(this);
    this.selecionarOpcao = this.selecionarOpcao.bind(this);
    this.passarQuestao = this.passarQuestao.bind(this);
    this.atualizarQuestao = this.atualizarQuestao.bind(this);
    this.finalizarProva = this.finalizarProva.bind(this);
    this.verificarQuestaoFinalInicial = this.verificarQuestaoFinalInicial.bind(this);
    this.checkAvailability = this.checkAvailability.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
    var atualizacao = this.atualizarQuestao(this.props.questaoSelecionada);
    var self = this;
    Promise.resolve(atualizacao).then(function(value) {
      self.verificarQuestaoFinalInicial();
      self.verificarQuestaoSelecionada();
    });
    this.checkAvailability();
  }

  componentWillReceiveProps(newProps) {
    this.setState({questoes_respondidas: newProps.questoesFeitas});
    var self = this;
    Object.keys(newProps.dadosProva).map(function(k) {
      if(self.state.exam_id === 0) {
        self.setState({exam_id: newProps.dadosProva[k].team_training_matter_staff_exam_id, exam_name: newProps.dadosProva[k].team_training_matter_staff_exam.exam_name});
      }
      if(newProps.dadosProva[k].training_id !== 'undefined' && newProps.dadosProva[k].training_id !== null){
        self.setState({exam_id: newProps.dadosProva[k].team_training_matter_staff_exam_id, exam_name: newProps.dadosProva[k].exam_name, training_name: newProps.dadosProva[k].training.name, matter_name: newProps.dadosProva[k].matter.name});
      }
    });
  }


  verificarQuestaoFinalInicial() {
    var primeira = 0;
    var self = this;
    Object.keys(this.props.dadosProva).map(function(k) {
      if (primeira === 0) {
        self.setState({primeira_questao: self.props.dadosProva[k].id});
        primeira = 1;
      }
      self.setState({ultima_questao: self.props.dadosProva[k].id});
    });
  }

  checkAvailability() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/usuario/checar_disponibilidade/' + self.state.exam_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if(parseInt(responseJson.data.availability) === 0) {
          self.finalizarProva('availability');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  atualizarQuestao (value) {
    this.setState({questaoSelecionada: value});
    return true;
  }

  atualizarQuestao (value) {
    this.setState({questaoSelecionada: value});
    return true;
  }

  finalizarProva (value) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/usuario/checar_disponibilidade/' + self.state.exam_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        var questoes_nao_respondidas = 0;
        var questoes_respondidas = 0;
        var params = JSON.parse(localStorage.getItem("prova"));
        Object.keys(params).map(function(k) {
          if (params[k].selected == null) {
            questoes_nao_respondidas++;
          } else {
            questoes_respondidas++;
          }
        })
        if(parseInt(responseJson.data.availability) === 0) {
          var confirm = true;
          var availability = 0;
        } else {
          var confirm = window.confirm('Questões não respondidas: ' + questoes_nao_respondidas + ' / Questões respondidas: ' + questoes_respondidas + ' Tem certeza que gostaria de finalizar essa prova?');
          var availability = 1;  
        }
        if (confirm) {
          self.setState({status_loading: 1});
          var dados_salvar = {
            data: params,
            availability: availability
          };
          var header = self.refs.request_api.header('application/json');
          Promise.resolve(header).then(function(value) {
            fetch(config.get('api') + '/prova/usuario/finalizar_prova', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
              var storage = {
                mensagem_alerta: responseJson.message,
                tipo_alerta: responseJson.status,
              };
              localStorage.setItem("verifica_mensagem", JSON.stringify(storage));
              localStorage.setItem("finalizada", JSON.stringify(responseJson.data));
              localStorage.removeItem("iniciada");
              localStorage.removeItem("lmhour");
              self.context.router.history.push('/usuario/provas');
            }).catch((error) => {
              console.error(error);
            });
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  selecionarOpcao (opcao_index) {
    this.desmarcarOpcoes();
    var opcoes = this.state.opcoes;
    opcoes[opcao_index].selected = 1;
    
    this.setState({opcoes: opcoes});
    this.props.questaoMarcarOpcao(opcoes[opcao_index].option_number, this.state.questaoSelecionada);
    this.checkAvailability();
  }

  desmarcarOpcoes () {
    var opcoes = this.state.opcoes;
    Object.keys(opcoes).map(function(k) {
      opcoes[k].selected = 0;
    })
    this.setState({opcoes: opcoes});
  }

  verificarQuestaoSelecionada () {
    if(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') {
      this.context.router.history.push('/usuario/prova');
    } else {
      var questao = this.props.dadosProva[this.state.questaoSelecionada];
      var opcoes = questao.team_training_matter_staff_exam_question_option;
      this.setState({questao: questao});
      this.setState({opcoes: opcoes});
      this.props.selecionarQuestao(questao.id);
    }
  }

  passarQuestao (questao_selecionada) {
    this.checkAvailability();
    var atualizacao = this.atualizarQuestao(questao_selecionada);
    var self = this;
    Promise.resolve(atualizacao).then(function(value) {
      self.verificarQuestaoSelecionada();
    });

  }

  render() {
    var self = this;
    return (
<div>
  <Topo dadosQuestoes={self.props.dadosProva} questoesFeitas={this.props.questoesFeitas} finalizarProva={this.finalizarProva}></Topo>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading !== 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {(this.state.status_alerta === 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
  <section>
    <div className="container prova-questao-container">
      <div className="row">
        <div className="col-md-9">
          <div className="card">
            <div className="card-cabecalho">
              <div className="row">
                <div className="col-md-6">
                  <h4>Questão {this.state.questao.question_number}:</h4>
                </div>
                <div className="col-md-6 text-right">
                  {(typeof this.state.questao.question === 'undefined') ?  '' : <h4>Cod. {this.state.questao.question.number} </h4> }
                </div>
              </div>
            </div>
            <div className="card-conteudo">
              <div className="row">
                <div className="col-md-12 question-content">
                  <div dangerouslySetInnerHTML={{__html: this.state.questao.question_content}}></div>
                </div>
              </div>
              <hr/>
              <table className="table tabela-questao-opcoes">
                <tbody>
                  {Object.keys(self.state.opcoes).map(function(k) {
                    return (
                      <tr>
                        <td className="checkbox-questao-opcoes"><div onClick={() => self.selecionarOpcao(k)} className={(self.state.opcoes[k].selected == 1) ? 'opcao-selecionada' : 'opcao'}>{(self.state.opcoes[k].selected == 1) ? 'X' : ''}</div></td>
                        <td style={{wordWrap: 'break-word'}}><span>{self.state.opcoes[k].option_number}) </span>{self.state.opcoes[k].option_name}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <hr/>
            <div className="card-conteudo">
              <div className="row botoes-trocar-questao">
                <div className="col-md-4">
                    {(parseInt(self.state.questao.question_number) === 1) ? 
                      <button disabled className="btn btn-block"><i className="fa fa-chevron-left" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;QUESTÃO ANTERIOR</button>
                      :
                      <button onClick={(parseInt(self.state.questao.question_number) === 1) ? () => self.passarQuestao(self.state.ultima_questao) : () => self.passarQuestao(parseInt(self.state.questao.id) - parseInt(1))}  className="btn btn-block"><i className="fa fa-chevron-left" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;QUESTÃO ANTERIOR</button>
                    }    
                </div>
                <div className="col-md-4 col-md-offset-4">
                  {(parseInt(self.state.questao.question_number) === self.props.qtd_questoes) ? 
                    <button disabled className="btn btn-block">PRÓXIMA QUESTÃO&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-chevron-right" aria-hidden="true"></i></button> 
                    : <button onClick={(parseInt(self.state.questao.question_number) === self.props.qtd_questoes) ? () => self.passarQuestao(self.state.primeira_questao) : () => self.passarQuestao(parseInt(self.state.questao.id) + parseInt(1))} className="btn btn-block">PRÓXIMA QUESTÃO&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-chevron-right" aria-hidden="true"></i></button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card">
            <div className="card-conteudo">
              <p><strong>Prova: </strong>{self.state.exam_name}</p>
              {(self.state.training_name) ? 
                <p><strong>Treinamento: </strong>{(self.state.training_name) ? self.state.training_name : ''}</p>
                : ""
              }
              {(self.state.matter_name) ? 
                <p><strong>Matéria: </strong>{(self.state.matter_name) ? self.state.matter_name : ''}</p>
                : ""
              }
            </div>
          </div>
          <div className="card">
            <div className="card-cabecalho">
              <h4><strong>Questões</strong></h4>
            </div>
            <div className="card-conteudo">
              <div className="row">
                {Object.keys(self.props.dadosProva).map(function(k) {
                  return (
                    <div className="col-md-4">
                      <div className="legenda-questoes-quadrados" onClick={() => self.passarQuestao(k)}>
                        <div className={(self.props.dadosProva[k].selected) ? 'legenda-questoes-quadrados-fundo-respondida' : 'legenda-questoes-quadrados-fundo-nao-respondida'}>
                          <p>{(self.props.dadosProva[k].selected) ? self.props.dadosProva[k].question_number + ' - ' + self.props.dadosProva[k].selected_str : self.props.dadosProva[k].question_number}</p>
                        </div>                    
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="legenda-questoes-finalizar-prova">
                  <BotaoFinalizarProva finalizarProva={self.finalizarProva} />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-cabecalho">
              <h4><strong>Legenda:</strong></h4>
            </div>
            <div className="card-conteudo">
              <div className="row legenda-questoes-linhas">
                <div className="col-md-8">
                  <div className="questao-respondida text-center">
                    <p>Questão Feita</p>
                  </div>
                </div>
                <div className="col-md-4"></div>
              </div>
              <div className="row legenda-questoes-linhas">
                <div className="col-md-8">
                  <div className="questao-nao-respondida text-center">
                    <p>Questão Pendente</p>
                  </div>
                </div>
                <div className="col-md-4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
    );
  }
}

ExamQuestion.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ExamQuestion;



// WEBPACK FOOTER //
// ./src/Components/Exams/ExamQuestion.js